/**
 * @file 文档的 api
 * @author wanzhongyun
 */
import request from 'superagent';
import baseRequest from '../baseApi';
import baseRequestText from '../baseApiText';

interface ISubmitFeedbackParams {
    question: string;
    screenshot: string;
    url: string;
}

// 提交反馈
export const fetchSubmitFeedback = (params: ISubmitFeedbackParams): Promise<request.Response> =>
    baseRequest(
        request.post('/platform/usercase/send')
            .query({type: 9})
            .send(params)
    );

// 获取文档 html
export const getDocumentHTML = (url?: string): Promise<request.Response> => {
    const docUrl = url || window.location.pathname + window.location.search;
    const docUrl2 = docUrl.replace(/#.*/, '');

    return baseRequestText(
        request.get(docUrl2)
            .query({raw: 'true'})
    );
};
